import { render, staticRenderFns } from "./h-like.vue?vue&type=template&id=21a8c7cc&"
import script from "./h-like.vue?vue&type=script&lang=js&"
export * from "./h-like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports